import React from 'react';
import './style/headerSection.css';


function HeaderSection() {
    return (
      <div className="header-div night-palette">
          <div className="title-div night-palette-7">Milano By Night</div>
          <div className="second-title-div night-palette-7">Find night events in Milan</div>
      </div>
    );
}

export default HeaderSection;